import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button, ButtonType } from '@src/components/Button'
import { useCookieConsent } from '@src/hooks/useCookieConsent/useCookieConsent'
import { useMarketplace } from '@src/hooks/useMarketplace'

import {
  BannerOverlay,
  BannerText,
  ButtonRow,
  CookiePolicyLink,
  PolicyLine,
} from './CookieConsentBanner.styles'

export const CookieConsentBanner: React.FC = () => {
  const { t } = useTranslation('policies')
  const { consent, acceptAll, rejectAll } = useCookieConsent()
  const marketplace = useMarketplace()

  // PostHog is keyed globally rather than per marketplace, so tracking runs even
  // when the marketplace configures neither GA4 nor a Meta pixel.
  const hasTracking = !!(
    marketplace.ga4Id ||
    marketplace.facebookPixelId ||
    import.meta.env.VITE_POSTHOG_KEY
  )

  if (!hasTracking || consent !== null) return null

  return (
    <BannerOverlay role="region" aria-label={t('cookie_consent_banner_label')}>
      <BannerText>
        {t('cookie_consent_message')}{' '}
        <PolicyLine>
          {t('cookie_consent_policy_prefix')}{' '}
          <CookiePolicyLink href="?account=cookies">
            {t('cookie_consent_policy_link')}
          </CookiePolicyLink>
        </PolicyLine>
      </BannerText>
      <ButtonRow>
        <Button
          buttonType={ButtonType.SECONDARY}
          content={t('cookie_consent_reject')}
          onClick={rejectAll}
          dataTestId="cookie-consent-reject"
        />
        <Button
          buttonType={ButtonType.PRIMARY}
          content={t('cookie_consent_accept')}
          onClick={acceptAll}
          dataTestId="cookie-consent-accept"
        />
      </ButtonRow>
    </BannerOverlay>
  )
}
